<template lang="pug">
  .component-invoice-list-filter-form.filter-form
    .row.medium-unstack
      .columns
        .fa.fa-search.fa-2x
      .columns
        selectize-driver(v-model="search.driver_id", @optionSelected="setDriverId")
      .columns
        input(type="text", v-model="search.chip_id", placeholder="Chip id")
      .columns
        a.fa.fa-angle-double-down.fa-2x(v-on:click="filterCards")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import DatePicker from 'components/structure/DatePicker'
  import SelectizeDriver from "../lists/selectize/SelectizeDriver";

  export default {
    name: "InvoiceListForm",
    components: {
      SelectizeDriver,
      KeplerBackofficeSdk,
      DatePicker,
    },
    data() {
      return {
        drivers: [],
        search: {
          "driver_id": null,
          "chip_id": null,
        }
      }
    },
    created() {
    },
    methods: {
      setDriverId(driver) {
        this.search.driver_id = driver.id
      },
      filterCards() {
        this.$emit('filterCards', this.search)
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// CardListForm.vue?67b308c4